var _defs, _g, _g2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGcemLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_74_1",
    "data-name": "Component 74 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 131.835,
    height: 48.758,
    viewBox: "0 0 131.835 48.758",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14907",
    "data-name": "Path 14907",
    d: "M26.494,64.821c-.058,0-.116,0-.175.008l0,0a3.866,3.866,0,0,0-2.7,1.4s-.008,0-.011,0a6.869,6.869,0,0,1-5.146,2.627A6.344,6.344,0,0,1,13.276,67l-.006,0a3.884,3.884,0,1,0,.212,5.489c.058-.063.115-.128.169-.195l.006.005a6.339,6.339,0,0,1,4.863-2.587,6.871,6.871,0,0,1,5.468,1.862H24a3.88,3.88,0,1,0,2.712-6.756Z",
    transform: "translate(-6.747 -64.821)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.099,
    y1: 2.334,
    x2: -0.082,
    y2: 2.334,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#990c47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#850c39"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14908",
    "data-name": "Path 14908",
    d: "M34.178,16.668a3.872,3.872,0,0,0-2.693,4.918s-.005.007-.006.01a6.864,6.864,0,0,1-.585,5.747,6.347,6.347,0,0,1-4.381,3.342v.007a3.883,3.883,0,1,0,4.725,2.8c-.021-.082-.044-.164-.071-.244l.007,0a6.343,6.343,0,0,1,.468-5.489,6.867,6.867,0,0,1,4.532-3.582s0-.006.006-.008a3.88,3.88,0,1,0-2-7.5",
    transform: "translate(-23.593 -16.536)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.148,
    y1: 1.726,
    x2: -0.133,
    y2: 1.726,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#90a529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f8f2f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14909",
    "data-name": "Path 14909",
    d: "M48.7,41.876h0A3.877,3.877,0,0,0,50.674,48.8s.006.005.009.006a6.858,6.858,0,0,1,5.034,2.827,6.337,6.337,0,0,1,1.323,5.349h.008A3.884,3.884,0,1,0,61.5,53.766c-.085-.014-.17-.025-.256-.033v-.008a6.339,6.339,0,0,1-4.851-2.616,6.864,6.864,0,0,1-1.479-5.582s-.006-.006,0-.009A3.878,3.878,0,0,0,48.7,41.876",
    transform: "translate(-47.192 -41.062)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.552,
    y1: 1.256,
    x2: -0.537,
    y2: 1.256,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d99d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0057a6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6801",
    "data-name": "Rectangle 6801",
    width: 131.133,
    height: 48.758,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15634",
    "data-name": "Group 15634",
    transform: "translate(2.852 6.988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15616",
    "data-name": "Group 15616",
    transform: "translate(0 20.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15615",
    "data-name": "Group 15615",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6798",
    "data-name": "Rectangle 6798",
    width: 24.593,
    height: 9.339,
    transform: "translate(-0.423 0)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15618",
    "data-name": "Group 15618",
    transform: "translate(7.119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15617",
    "data-name": "Group 15617",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6799",
    "data-name": "Rectangle 6799",
    width: 27.315,
    height: 24.977,
    transform: "translate(-9.779 17.069) rotate(-61.236)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15620",
    "data-name": "Group 15620",
    transform: "translate(17.091 10.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15619",
    "data-name": "Group 15619",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6800",
    "data-name": "Rectangle 6800",
    width: 27.202,
    height: 27.623,
    transform: "matrix(0.791, -0.612, 0.612, 0.791, -10.526, 7.757)",
    fill: "url(#linear-gradient-3)"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15622",
    "data-name": "Group 15622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15621",
    "data-name": "Group 15621",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14910",
    "data-name": "Path 14910",
    d: "M103.548,47.949a10.5,10.5,0,0,1-5.291-1.318,8.933,8.933,0,0,1-3.6-3.887,13.867,13.867,0,0,1-1.285-6.255A13.129,13.129,0,0,1,94.724,30.3,9.424,9.424,0,0,1,98.6,26.346a13.869,13.869,0,0,1,12.052-.017,8.93,8.93,0,0,1,3.617,4.344L108.89,32.8a4.155,4.155,0,0,0-1.555-2.5,4.735,4.735,0,0,0-2.772-.778,4.975,4.975,0,0,0-2.84.794,4.868,4.868,0,0,0-1.792,2.333,10.391,10.391,0,0,0-.609,3.8,10.851,10.851,0,0,0,.625,3.955,4.636,4.636,0,0,0,1.859,2.35,5.73,5.73,0,0,0,3.06.761,6.375,6.375,0,0,0,1.792-.237,4.379,4.379,0,0,0,1.42-.693,3.13,3.13,0,0,0,.947-1.149,3.712,3.712,0,0,0,.338-1.64v-.338h-5.1V35.575H114.3V47.611h-3.955l-.439-5.24.947.811a6.349,6.349,0,0,1-2.552,3.533,8.376,8.376,0,0,1-4.75,1.234",
    transform: "translate(-53.914 -14.412)",
    fill: "#141212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14911",
    "data-name": "Path 14911",
    d: "M167.136,41.221a8.929,8.929,0,0,1-2.062,3.837,8.454,8.454,0,0,1-3.381,2.2,12.917,12.917,0,0,1-4.327.693,11.87,11.87,0,0,1-5.849-1.369,9.19,9.19,0,0,1-3.786-3.939,13.407,13.407,0,0,1-1.318-6.187,13.412,13.412,0,0,1,1.318-6.187,9.2,9.2,0,0,1,3.786-3.939,11.8,11.8,0,0,1,5.815-1.369,13.4,13.4,0,0,1,4.294.659,8.393,8.393,0,0,1,3.313,2.012,7.627,7.627,0,0,1,1.927,3.482l-5.1,2.062a4.712,4.712,0,0,0-1.538-2.874,4.441,4.441,0,0,0-2.688-.778,4.852,4.852,0,0,0-2.755.778,4.9,4.9,0,0,0-1.792,2.316,10.23,10.23,0,0,0-.625,3.837,11.07,11.07,0,0,0,.575,3.82,4.615,4.615,0,0,0,1.741,2.333,5.094,5.094,0,0,0,2.891.778,4.3,4.3,0,0,0,2.755-.9,4.62,4.62,0,0,0,1.538-2.755Z",
    transform: "translate(-84.539 -14.412)",
    fill: "#141212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14912",
    "data-name": "Path 14912",
    d: "M199.931,48.072V25.759h17.377v4.5H205.746v4.53h9.2v4.226h-9.2v4.564h12v4.5Z",
    transform: "translate(-115.442 -14.873)",
    fill: "#141212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14913",
    "data-name": "Path 14913",
    d: "M273.04,25.759V48.072H267.9V37.828l.169-6.863H268l-5.511,17.107h-4.7l-5.511-17.107h-.068l.169,6.863V48.072h-5.173V25.759h8.283l3.516,11.359,1.251,4.733h.068l1.285-4.7L265.1,25.759Z",
    transform: "translate(-142.742 -14.873)",
    fill: "#141212"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14914",
    "data-name": "Path 14914",
    d: "M6.661-9.35l-1.19-.356a1.344,1.344,0,0,1-1.424,1.1c-1.04,0-1.649-.759-1.649-2.126s.646-2.126,1.677-2.126a1.222,1.222,0,0,1,1.33,1.04l1.171-.5a2.426,2.426,0,0,0-2.557-1.6,2.854,2.854,0,0,0-2.96,3.185A2.854,2.854,0,0,0,4.039-7.552,2.536,2.536,0,0,0,6.661-9.35ZM9.79-12.422a2.217,2.217,0,0,0-2.4,2.435,2.217,2.217,0,0,0,2.4,2.435,2.217,2.217,0,0,0,2.4-2.435A2.217,2.217,0,0,0,9.79-12.422Zm0,.955c.721,0,1.115.487,1.115,1.48s-.393,1.48-1.115,1.48-1.115-.487-1.115-1.48S9.068-11.467,9.79-11.467Zm9.367-.955a1.714,1.714,0,0,0-1.592.946,1.552,1.552,0,0,0-1.527-.946,1.653,1.653,0,0,0-1.545.918l-.047-.824H13.293v4.683h1.283v-2.482c0-.918.534-1.283,1.03-1.283.478,0,.815.262.815.946v2.819H17.7v-2.52c0-.815.459-1.246,1.03-1.246.468,0,.806.262.806.946v2.819h1.274l.009-3.072A1.568,1.568,0,0,0,19.156-12.422Zm5.742,0a1.654,1.654,0,0,0-1.574,1l-.047-.909H22.144v6.65h1.283V-8.423a1.585,1.585,0,0,0,1.471.871c1.236,0,2-.909,2-2.445S26.144-12.422,24.9-12.422Zm-.384,3.887c-.674,0-1.087-.515-1.087-1.4v-.094c0-.909.421-1.4,1.087-1.4.684,0,1.1.5,1.1,1.452S25.2-8.535,24.514-8.535Zm6.173-3.887a1.442,1.442,0,0,0-1.452,1.012l-.084-.918H28.036v4.683h1.283v-2.426a1.143,1.143,0,0,1,1.124-1.264,1.142,1.142,0,0,1,.59.141l.159-1.124A1.073,1.073,0,0,0,30.687-12.422Zm5.583,2.417a2.118,2.118,0,0,0-2.257-2.417,2.185,2.185,0,0,0-2.36,2.435,2.219,2.219,0,0,0,2.435,2.435A2.02,2.02,0,0,0,36.166-8.7l-1.049-.384a.972.972,0,0,1-1.03.581A1.1,1.1,0,0,1,32.916-9.5h3.316A4.43,4.43,0,0,0,36.269-10.006ZM34-11.476c.59,0,.984.375,1.087,1.077H32.907C33.01-11.111,33.384-11.476,34-11.476Zm6.135-.946a1.588,1.588,0,0,0-1.508.89V-14.38H37.346v6.735H38.63v-2.473c0-.937.534-1.293,1.077-1.293.487,0,.834.262.834,1.068v2.7h1.283v-3.072A1.565,1.565,0,0,0,40.138-12.422Zm7.381,2.417a2.118,2.118,0,0,0-2.257-2.417A2.185,2.185,0,0,0,42.9-9.987a2.219,2.219,0,0,0,2.435,2.435A2.02,2.02,0,0,0,47.416-8.7l-1.049-.384a.972.972,0,0,1-1.03.581A1.1,1.1,0,0,1,44.165-9.5h3.316A4.43,4.43,0,0,0,47.519-10.006Zm-2.267-1.471c.59,0,.983.375,1.087,1.077H44.156C44.259-11.111,44.634-11.476,45.252-11.476Zm6.135-.946a1.668,1.668,0,0,0-1.592.927l-.047-.834H48.6v4.683h1.283v-2.473c0-.937.534-1.293,1.077-1.293.487,0,.834.262.834,1.068v2.7h1.283v-3.072A1.565,1.565,0,0,0,51.387-12.422Zm4.824,4.871c1.4,0,2.136-.609,2.136-1.452,0-.777-.506-1.19-1.873-1.461-.787-.159-1.021-.318-1.021-.571s.318-.45.843-.45a1.31,1.31,0,0,1,1.274.731l.8-.674a2.162,2.162,0,0,0-2.089-.993c-1.386,0-2.107.749-2.107,1.508,0,.777.487,1.227,1.948,1.517.684.141.937.272.937.487,0,.253-.309.421-.862.421a1.37,1.37,0,0,1-1.4-.731l-.749.768A2.461,2.461,0,0,0,56.211-7.552ZM60.014-13c.534,0,.8-.225.8-.684s-.262-.693-.8-.693-.8.234-.8.693S59.48-13,60.014-13Zm.637.674H59.367v4.683h1.283Zm4.43,0L63.9-8.545l-1.152-3.784H61.372l1.78,4.683h1.48l1.78-4.683Zm6.351,2.323a2.118,2.118,0,0,0-2.257-2.417,2.185,2.185,0,0,0-2.36,2.435,2.219,2.219,0,0,0,2.435,2.435A2.02,2.02,0,0,0,71.329-8.7L70.28-9.088a.972.972,0,0,1-1.03.581A1.1,1.1,0,0,1,68.078-9.5h3.316A4.428,4.428,0,0,0,71.432-10.006Zm-2.267-1.471c.59,0,.983.375,1.087,1.077H68.069C68.172-11.111,68.547-11.476,69.165-11.476ZM80.2-13.827H74.757v1.04h2.079v5.142h1.293v-5.142H80.2ZM85.931-8.47a1.257,1.257,0,0,1-1.1-.412,3,3,0,0,0,.6-1.948l-.89-.047a2.75,2.75,0,0,1-.272,1.424c-.2-.215-.412-.468-.674-.768l-.525-.609c.984-.44,1.311-.993,1.311-1.7,0-.852-.646-1.4-1.7-1.4a1.55,1.55,0,0,0-1.723,1.5,2.131,2.131,0,0,0,.674,1.471A1.854,1.854,0,0,0,80.283-9.2c0,1.021.862,1.649,2.1,1.649a2.639,2.639,0,0,0,1.8-.637,2.059,2.059,0,0,0,1.592.637ZM82.7-13.022c.393,0,.637.178.637.553,0,.356-.084.684-.721,1.1-.45-.543-.534-.74-.534-1.021A.582.582,0,0,1,82.7-13.022ZM81.4-9.294c0-.375.141-.646.749-1.058.215.253.478.534.777.862.253.29.478.534.684.749a2.237,2.237,0,0,1-1.143.3C81.866-8.442,81.4-8.788,81.4-9.294ZM92.038-9.35l-1.19-.356a1.344,1.344,0,0,1-1.424,1.1c-1.04,0-1.649-.759-1.649-2.126s.646-2.126,1.677-2.126a1.222,1.222,0,0,1,1.33,1.04l1.171-.5a2.426,2.426,0,0,0-2.557-1.6,2.854,2.854,0,0,0-2.96,3.185,2.854,2.854,0,0,0,2.979,3.185A2.536,2.536,0,0,0,92.038-9.35Zm8.664-4.477H95.26v1.04H97.34v5.142h1.293v-5.142h2.07Zm2.96,1.4a1.442,1.442,0,0,0-1.452,1.012l-.084-.918h-1.115v4.683h1.283v-2.426a1.143,1.143,0,0,1,1.124-1.264,1.142,1.142,0,0,1,.59.141l.159-1.124A1.073,1.073,0,0,0,103.662-12.422Zm5.5,4c-.244,0-.347-.112-.347-.356V-10.7c0-1.161-.824-1.723-2.126-1.723a1.861,1.861,0,0,0-2.042,1.3l1.021.431a.971.971,0,0,1,1.077-.8.743.743,0,0,1,.8.815v.225l-1.124.215c-1.255.234-1.826.749-1.826,1.48,0,.787.562,1.2,1.452,1.2a1.838,1.838,0,0,0,1.658-.7c.131.506.515.7,1.077.7a1.358,1.358,0,0,0,.609-.131l.094-.777A1.143,1.143,0,0,1,109.161-8.423Zm-2.716,0c-.337,0-.534-.159-.534-.459s.215-.459.628-.553l1-.225v.487C107.54-8.676,106.931-8.423,106.444-8.423Zm5.938-4a2.21,2.21,0,0,0-2.388,2.435,2.219,2.219,0,0,0,2.435,2.435,1.954,1.954,0,0,0,2.117-1.414l-1.161-.375a.9.9,0,0,1-.974.834c-.693,0-1.133-.468-1.133-1.471,0-.983.412-1.489,1.143-1.489.5,0,.8.29.909.852l1.2-.431A1.951,1.951,0,0,0,112.383-12.422ZM119-7.645h1.452l-1.873-2.847,1.761-1.836h-1.452l-2.033,2.145v-4.2h-1.283v6.735h1.283V-8.807l.852-.909Zm6.36-2.36a2.118,2.118,0,0,0-2.257-2.417,2.185,2.185,0,0,0-2.36,2.435,2.219,2.219,0,0,0,2.435,2.435A2.02,2.02,0,0,0,125.253-8.7L124.2-9.088a.972.972,0,0,1-1.03.581A1.1,1.1,0,0,1,122-9.5h3.316A4.431,4.431,0,0,0,125.356-10.006Zm-2.267-1.471c.59,0,.984.375,1.087,1.077h-2.182C122.1-11.111,122.471-11.476,123.089-11.476Zm5.995-.946a1.442,1.442,0,0,0-1.452,1.012l-.084-.918h-1.115v4.683h1.283v-2.426a1.143,1.143,0,0,1,1.124-1.264,1.142,1.142,0,0,1,.59.141l.159-1.124A1.073,1.073,0,0,0,129.084-12.422Z",
    transform: "translate(2.246 53.542)",
    fill: "#141212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcemLogo);
export default __webpack_public_path__ + "static/media/GCEM_Logo.45dc9acf1c65e9fe8d0b307220938da2.svg";
export { ForwardRef as ReactComponent };